module.exports = __webpack_public_path__ + "static/illust01_sp-9a84e5732fd58c61e0913034c6f752c5.png";